import {useEffect} from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";
import lscache from "lscache";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {PreferencesSurveySource} from "@pg-rp/common-types";

import {HOTLINE_LISTING_POPUP_SEEN} from "../../app/constants/storage_keys";
import {IRPStore} from "../../app/rp_reducer";
import {FeedbackPopup} from "../../atoms/chat_bot/feedback_popup/components/FeedbackPopup";
import {useFeedbackPopup} from "../../atoms/chat_bot/feedback_popup/hooks/use_feedback_popup";
import {openForYouModal} from "../../for_you/state/for_you_modal_slice";
import {ForYouOpenType} from "../../for_you/types/ForYouOpenType";
import {OfferType} from "../../offer/types/OfferType";
import {useAppDispatch} from "../../store/hooks";
import {useHotlinePopupGtmTracking} from "../tracking/hotline_popup_tracking";
import {HotlineConsultantsImages} from "./HotlineConsultantsImages";
import {HotlineInfoPoints} from "./HotlineInfoPoints";

interface IProps {
    offerTypes: OfferType[];
}

export const HotlineListingPopup = ({offerTypes}: IProps) => {
    const selectedRegions = useSelector((state: IRPStore) => state.offerList.selectedRegions);
    const dispatch = useAppDispatch();
    const tracking = useHotlinePopupGtmTracking(selectedRegions.map((region) => region.name).join(", "));

    const savePopupSeen = () => {
        // stored for 1 day
        lscache.set(HOTLINE_LISTING_POPUP_SEEN, true, 24 * 60);
    };

    const getPopupInfoFromStore = () => {
        return lscache.get(HOTLINE_LISTING_POPUP_SEEN);
    };

    const {feedbackPopupProps, setIsOpen} = useFeedbackPopup({
        onOpen: () => {
            savePopupSeen();
            tracking.hitView();
        }
    });

    useEffect(() => {
        const wasPopupOpen = getPopupInfoFromStore();
        if (!wasPopupOpen) {
            const timeout = setTimeout(() => {
                setIsOpen(true);
                tracking.hitView();
                savePopupSeen();
            }, 40000);

            return () => {
                clearTimeout(timeout);
            };
        }
    }, []);

    const onCtaClick = () => {
        tracking.hitButtonClick(ctaButtonLabel);
        dispatch(openForYouModal({types: offerTypes, source: PreferencesSurveySource.LISTING_ASSISTANT, openFrom: ForYouOpenType.WIDGET}));
        feedbackPopupProps.onClose();
    };

    return (
        <FeedbackPopup
            position="left"
            triggerMobile={{prompt: "1"}}
            triggerDesktop={{
                slot: (
                    <Text variant="info_txt_1" as="span">
                        Asystent oferty
                    </Text>
                )
            }}
            {...feedbackPopupProps}
        >
            <div className={contentStyle}>
                <HotlineConsultantsImages />

                <Text variant="headline_5" as="p" align="center" mb={1}>
                    Nie chcesz szukać samodzielnie?
                </Text>

                <Text variant="body_copy_2" align="center" mb={3}>
                    Zostaw kontakt, a doradca przygotuje dla Ciebie zestawienie mieszkań.
                </Text>

                <HotlineInfoPoints />

                <div className={ctaStyle}>
                    <Button variant="filled_primary" onClick={onCtaClick}>
                        {ctaButtonLabel}
                    </Button>
                </div>
            </div>
        </FeedbackPopup>
    );
};

const ctaButtonLabel = "Zamów rozmowę";

const contentStyle = css({
    p: 1,
    maxW: "296px",
    mx: "auto"
});

const ctaStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 1
});
import {useEffect} from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";
import lscache from "lscache";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {PreferencesSurveySource} from "@pg-rp/common-types";

import {HOTLINE_LISTING_POPUP_SEEN} from "../../app/constants/storage_keys";
import {IRPStore} from "../../app/rp_reducer";
import {FeedbackPopup} from "../../atoms/chat_bot/feedback_popup/components/FeedbackPopup";
import {useFeedbackPopup} from "../../atoms/chat_bot/feedback_popup/hooks/use_feedback_popup";
import {openForYouModal} from "../../for_you/state/for_you_modal_slice";
import {ForYouOpenType} from "../../for_you/types/ForYouOpenType";
import {OfferType} from "../../offer/types/OfferType";
import {useAppDispatch} from "../../store/hooks";
import {useHotlinePopupGtmTracking} from "../tracking/hotline_popup_tracking";
import {HotlineConsultantsImages} from "./HotlineConsultantsImages";
import {HotlineInfoPoints} from "./HotlineInfoPoints";

interface IProps {
    offerTypes: OfferType[];
}

export const HotlineListingPopup = ({offerTypes}: IProps) => {
    const selectedRegions = useSelector((state: IRPStore) => state.offerList.selectedRegions);
    const dispatch = useAppDispatch();
    const tracking = useHotlinePopupGtmTracking(selectedRegions.map((region) => region.name).join(", "));

    const savePopupSeen = () => {
        // stored for 1 day
        lscache.set(HOTLINE_LISTING_POPUP_SEEN, true, 24 * 60);
    };

    const getPopupInfoFromStore = () => {
        return lscache.get(HOTLINE_LISTING_POPUP_SEEN);
    };

    const {feedbackPopupProps, setIsOpen} = useFeedbackPopup({
        onOpen: () => {
            savePopupSeen();
            tracking.hitView();
        }
    });

    useEffect(() => {
        const wasPopupOpen = getPopupInfoFromStore();
        if (!wasPopupOpen) {
            const timeout = setTimeout(() => {
                setIsOpen(true);
                tracking.hitView();
                savePopupSeen();
            }, 40000);

            return () => {
                clearTimeout(timeout);
            };
        }
    }, []);

    const onCtaClick = () => {
        tracking.hitButtonClick(ctaButtonLabel);
        dispatch(openForYouModal({types: offerTypes, source: PreferencesSurveySource.LISTING_ASSISTANT, openFrom: ForYouOpenType.WIDGET}));
        feedbackPopupProps.onClose();
    };

    return (
        <FeedbackPopup
            position="left"
            triggerMobile={{prompt: "1"}}
            triggerDesktop={{
                slot: (
                    <Text variant="info_txt_1" as="span">
                        Asystent oferty
                    </Text>
                )
            }}
            {...feedbackPopupProps}
        >
            <div className={contentStyle}>
                <HotlineConsultantsImages />

                <Text variant="headline_5" as="p" align="center" mb={1}>
                    Nie chcesz szukać samodzielnie?
                </Text>

                <Text variant="body_copy_2" align="center" mb={3}>
                    Zostaw kontakt, a doradca przygotuje dla Ciebie zestawienie mieszkań.
                </Text>

                <HotlineInfoPoints />

                <div className={ctaStyle}>
                    <Button variant="filled_primary" onClick={onCtaClick}>
                        {ctaButtonLabel}
                    </Button>
                </div>
            </div>
        </FeedbackPopup>
    );
};

const ctaButtonLabel = "Zamów rozmowę";

const contentStyle = css({
    p: 1,
    maxW: "296px",
    mx: "auto"
});

const ctaStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 1
});
